import { useState } from 'react'

interface UseEditableFieldProps<T extends string> {
  initialValue: T | 'none'
}

interface UseEditableFieldReturn<T extends string> {
  isEditing: boolean
  selectedField: T | 'none'
  startEditing: (fieldName: T) => void
  cancelEditing: () => void
  saveChanges: () => void
}

function useEditableField<T extends string>({
  initialValue = 'none',
}: UseEditableFieldProps<T>): UseEditableFieldReturn<T> {
  const [selectedField, setSelectedField] = useState<T | 'none'>(initialValue)

  const isEditing = selectedField !== 'none'

  const startEditing = (fieldName: T) => {
    setSelectedField(fieldName)
  }

  const cancelEditing = () => {
    setSelectedField('none')
  }

  const saveChanges = () => {
    setSelectedField('none')
  }

  return {
    isEditing,
    selectedField,
    startEditing,
    cancelEditing,
    saveChanges,
  }
}

export default useEditableField
